import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 3;
  font-family: 'Source Sans Pro', sans-serif;
`;

export const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  text-align: center;
  position: relative;
  z-index: 2;
  width: ${props => props.theme.container.wider.width};
  font-size: ${props => props.theme.footer.fontSize};
  a {
    color: ${props => props.theme.primaryColor};
  }

  ${media.medium`
    width: 100%;
  `};
  ${media.small`
    a,
    span {
      color: ${props => props.theme.quaternaryColor};
    }
  `};
`;

export const Logo = styled.img`
  height: 14rem;
  margin: 1.8rem 2.4rem 1.8rem 0;
  cursor: pointer;
  ${media.medium`
    height: 10rem;
    margin: 1.8rem;
  `};
  ${media.small`
    display: none;
  `};
`;

export const Navs = styled.div`
  display: flex;
  padding: ${props => props.theme.padding};
  aside {
    display: none;
  }
  nav {
    width: auto;
  }

  ${media.small`
    width: 100%;
    background-color: ${p => p.theme.primaryColor};
    padding: 0;
    aside {
      display: block;
    }
    nav {
      width: 100%;
    }
  `};
`;



// WEBPACK FOOTER //
// ./components/LightHeader/LightHeader.style.js